import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {UserService} from '../../../services/user.service';
import {Err} from '../../../err';
import {NotificationService} from '../../../services/notification.service';
import {environment} from '../../../../environments/environment';

@Component({
  templateUrl: './activate-account.component.html',
  styleUrls: ['./activate-account.component.scss']
})
export class ActivateAccountComponent implements OnInit {

  code: string;
  error: string;
  userId: number;

  constructor(
    private service: UserService,
    private notificationService: NotificationService,
    private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.userId = params['userId'];
    });
  }

  resendActivationCode() {
    this.service.sendActivationMailById(this.userId).subscribe(() => {
      this.notificationService.success('er is een nieuw activatie-e-mail verstuurd!');
    });
  }

  codeChanged($event) {
    if ($event.trim().length === 15) {
      this.service.activateUser({userId: this.userId, code: $event.trim()}).subscribe(hash => {
        this.service.sendWelcomeEmail(this.userId, hash).subscribe(() => this.thankYou());
      }, response => {
        const error = Err[response.error.message];
        if (error === Err.USER_ALREADY_ACTIVATED)
          this.thankYou();
        this.error = error;
      });
    }
  }

  thankYou() {
    window.location.href = environment.registrationThankYouPage;
  }
}
